import React from "react";
import { toast } from "react-toastify";
import { Avatar, Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { PhotoCamera } from "@mui/icons-material";

import { CardLayout } from "../v3";
import { USER_AVATAR } from "../../utils/image.constants";
import { formatBalance, getBalanceColor } from "../../utils";

export const ProfileCard = ({ userDetails = {} }) => {
  const handleUpdateProfile = () => toast.info("Updating the profile photo is not available at this time.");

  const primaryAddress = [
    userDetails?.primaryAddress?.locality,
    userDetails?.primaryAddress?.state,
    userDetails?.primaryAddress?.pinCode,
    userDetails?.primaryAddress?.country,
  ].filter(Boolean);

  const invertBalance = (balance) => -(Number(balance) || 0);

  return (
    <CardLayout sx={{ padding: "16px 20px" }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" spacing={2} alignItems="center">
          {/* Avatar */}
          <Box sx={{ position: "relative", width: 56, height: 56 }}>
            <Avatar
              src={USER_AVATAR}
              alt="User Avatar"
              sx={{
                width: 56,
                height: 56,
                backgroundColor: "#F2ECF9",
              }}
            />

            {/* Camera Icon */}
            <Tooltip title="Update profile photo" arrow>
              <IconButton
                size="small"
                onClick={handleUpdateProfile}
                sx={{
                  position: "absolute",
                  bottom: -4,
                  right: -4,
                  width: 22,
                  height: 22,
                  backgroundColor: "#fff",
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                <PhotoCamera sx={{ fontSize: 14 }} />
              </IconButton>
            </Tooltip>
          </Box>

          {/* User Info */}
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
              {userDetails?.firstName} {userDetails?.lastName}
            </Typography>

            <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 500 }}>
              {userDetails?.type}
            </Typography>

            {primaryAddress.length > 0 && (
              <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 500 }}>
                {primaryAddress.join(", ")}
              </Typography>
            )}
          </Box>
        </Stack>

        <Box textAlign="right">
          <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 500 }}>
            Balance
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, color: getBalanceColor(Number(userDetails?.accounts?.[0]?.balance)) }}
          >
            {formatBalance(invertBalance(userDetails?.accounts?.[0]?.balance))}
          </Typography>
        </Box>
      </Stack>
    </CardLayout>
  );
};
